import script from "./ClubGalleryPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubGalleryPublic.vue?vue&type=script&setup=true&lang=js"

import "./ClubGalleryPublic.vue?vue&type=style&index=0&id=0cb6490e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb6490e"]])

export default __exports__